module.exports = __webpack_public_path__ + "static/feedback-14dc4395714d915394290027a66f6b05.png";